import script from "./PriorityMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorityMapping.vue?vue&type=script&setup=true&lang=js"

import "./PriorityMapping.vue?vue&type=style&index=0&id=2f241d97&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f241d97"]])

export default __exports__